// Local shim for `@s-ui/react-router`.
//
// Aliased in `vite.config.js` via `resolve.alias`, so every `import ... from
// '@s-ui/react-router'` in the app and in `packages/ui` is routed here; this file loads the
// real compatibility shim (`@adv-mt/shim-react-router`) directly, which the alias leaves
// alone.
//
// The reason for the shim: `push`/`replace` are the only way `packages/ui` navigates, and the
// `state` they carry is what the destination's RR7 loader cannot see (see
// `navigationStateCache.ts`). Recording it here covers every caller at once instead of
// leaving each one to remember, which is how the listing→detail Segment attribution went
// missing in the first place.
import {useMemo} from 'react'

import {
  Link,
  NavLink,
  RouterContext,
  useLocation,
  useParams,
  useRouter as baseUseRouter
} from '@adv-mt/shim-react-router'

import {setNavigationState} from './navigationStateCache.ts'

export {Link, NavLink, RouterContext, useLocation, useParams}

const recordNavigationState = navigate => target => {
  if (typeof target === 'object' && target !== null) {
    setNavigationState(target.pathname ?? '', target.state)
  }

  return navigate(target)
}

export const useRouter = () => {
  const router = baseUseRouter()

  return useMemo(
    () => ({
      ...router,
      push: recordNavigationState(router.push),
      replace: recordNavigationState(router.replace)
    }),
    [router]
  )
}
